import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '../../util';
import { Subscription } from 'rxjs';

import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { toast } from 'angular2-materialize';

@Component({
    selector: 'app-read-customer',
    templateUrl: './read-customer.component.html',
    styleUrls: ['./read-customer.component.css', '../../app.component.css']
})

export class ReadCustomerComponent implements OnInit, OnDestroy {
    allowed: boolean = false;
    permission: any = {};

	customers: any[] = [];
	customersSub: Subscription;

	data: Array<any>;
	rows: Array<any> = [];
	columns: Array<any> = [
		{ title: 'Nombre', name: 'name', sort: 'asc' },
		{ title: 'Descripción', name: 'description' },
		{ title: 'Correo electrónico', className: 'center', name: 'email' },
		{ title: 'Cliente desde', className: 'center', name: 'clientSince' },
		{ title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
				styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
				styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
	];

	page = 1;
	itemsPerPage = 10;
	maxSize = 5;
	numPages = 1;
	length = 0;
	config: any = {
		paging: true,
		sorting: { columns: this.columns },
		filtering: { filterString: '' },
		api: {
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
	};

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private service: CustomerSupplierService,
		private permissionService: PermissionService,
		private authService: AuthService
	) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, 'customer');
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
		});
		
		this.loadCustomers();
	}

	ngOnInit() {

	}
	ngOnDestroy() {
		this.customersSub.unsubscribe();
	}

	loadCustomers() {
		this.customersSub = this.service.getCustomers().subscribe(tempCustomers => {
			localStorage.customersJson = JSON.stringify( tempCustomers.reduce((acc, cur) => {
				acc[cur.description] = cur.id$;
				return acc;
			}, {}) );
			this.customers = [];

			for (const idx in tempCustomers) {
				if (tempCustomers[idx].clientSince) {
					tempCustomers[idx].clientSince = Utils.convertDatefromStringtoISOString(tempCustomers[idx].clientSince);
				}

				this.customers.push(tempCustomers[idx]);
			}

			if(localStorage.re_customer__page){
				this.page = +localStorage.re_customer__page;
			}
			this.data = this.customers;
			this.length = this.data.length;
			this.onChangeTable(this.config);
		});
	}

	onCellClick(data: any): any {
		this.router.navigate(['/vw_customer/' + data.row.id$ + '/addresses']);
	}

    onCreate(){
		if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
		this.router.navigate(['/add_customer']);
    }

	onEdit(data: any) {
		if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.router.navigate(['/edt_customer/', data.row.id$]);
	}

	onDelete(data: any) {
		if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
		this.deleteCustomer(data.row.id$);
	}

	deleteCustomer(id$) {
		this.service.delCustomerSupplier(id$);
		this.loadCustomers();
	}

	// *************** Table functionality *************** //
	changePage(page: any, data: Array<any> = this.data): Array<any> {
		localStorage.re_customer__page = `${page.page}`;
		let start = (page.page - 1) * page.itemsPerPage;
		let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

		return data.slice(start, end);
	}

	changeSort(data: any, config: any): any {
		if (!config.sorting) {
			return data;
		}

		let columns = this.config.sorting.columns;
		let columnName: string;
		let sort: string;

		for (let i = 0; i < columns.length; i++) {
			if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
				columnName = columns[i].name;
				sort = columns[i].sort;
			}
		}

		if (!columnName) {
			return data;
		}

		// simple sorting
		return data.sort((previous: any, current: any) => {
			if (previous[columnName] > current[columnName]) {
				return sort === 'desc' ? -1 : 1;
			} else if (previous[columnName] < current[columnName]) {
				return sort === 'asc' ? -1 : 1;
			}

			return 0;
		});
	}

	changeFilter(data: any, config: any): any {
		let filteredData: Array<any> = data;

		this.columns.forEach((column: any) => {
			if (column.filtering) {
				filteredData = filteredData.filter((item: any) => {
					return item[column.name].match(column.filtering.filterString);
				});
			}
		});

		if (!config.filtering) {
			return filteredData;
		}

		if (config.filtering.columnName) {
			return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
		}

		let tempArray: Array<any> = [];

		filteredData.forEach((item: any) => {
			let flag = false;

			this.columns.forEach((column: any) => {
				if (item[column.name] &&
					item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
					flag = true;
				}
			});

			if (flag) {
				tempArray.push(item);
			}
		});

		filteredData = tempArray;

		return filteredData;
	}

	onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
		if (config.filtering) {
			Object.assign(this.config.filtering, config.filtering);
		}

		if (config.sorting) {
			Object.assign(this.config.sorting, config.sorting);
		}

		let filteredData = this.changeFilter(this.data, this.config);
		let sortedData = this.changeSort(filteredData, this.config);

		this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
		this.length = sortedData.length;
	}

}
